/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendStandardProductDto } from '../../models/backend-standard-product-dto';

export interface SalesStandardProductsRetrieve$Params {
  id: number;
}

export function salesStandardProductsRetrieve(
  http: HttpClient,
  rootUrl: string,
  params: SalesStandardProductsRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendStandardProductDto>> {
  const rb = new RequestBuilder(rootUrl, salesStandardProductsRetrieve.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendStandardProductDto>;
    }),
  );
}

salesStandardProductsRetrieve.PATH = '/api/sales/standard-products/{id}/';
